import ConfirmationIndex from '../components/Confirmation/Index'
import ConfirmationForm from '../components/Confirmation/Form'
import ConfirmationCreate from '../components/Confirmation/Create'

export default [
  {
    path: '/confirmations',
    name: 'confirmationIndex',
    component: ConfirmationIndex,
    meta: {
      breadcrumbs: [
        { text: 'A. 整合性の確認表作成準備入力' },
        { text: '整合性確認表の選択' },
      ],
    },
  },
  {
    path: '/confirmations/create',
    name: 'confirmationNew',
    component: ConfirmationCreate,
    props: {
      isNew: true,
      step: 0,
    },
    meta: {
      breadcrumbs: [
        { text: 'A. 整合性の確認表作成準備入力' },
        { text: '整合性確認表の作成 (案件情報の入力)' },
      ],
    },
  },
  // 編集フロー
  {
    path: '/confirmations/edit/step1/:id',
    name: 'confirmationEditStep1',
    component: ConfirmationForm,
    props: route => ({
      isNew: false,
      step: 1,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'A. 整合性の確認表作成準備入力', to: { name: 'confirmationIndex' }, exact: true },
        { text: '対象物件情報の入力' },
      ],
    },
  },
  {
    path: '/confirmations/edit/step2/:id',
    name: 'confirmationEditStep2',
    component: ConfirmationForm,
    props: route => ({
      isNew: false,
      step: 2,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'A. 整合性の確認表作成準備入力', to: { name: 'confirmationIndex' }, exact: true },
        { text: '調査情報の入力' },
      ],
    },
  },
  {
    path: '/confirmations/edit/step3/:id',
    name: 'confirmationEditStep3',
    component: ConfirmationForm,
    props: route => ({
      isNew: false,
      step: 3,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'A. 整合性の確認表作成準備入力', to: { name: 'confirmationIndex' }, exact: true },
        { text: '部屋情報の入力' },
      ],
    },
  },
  {
    path: '/confirmations/edit/step4/:id',
    name: 'confirmationEditStep4',
    component: ConfirmationForm,
    props: route => ({
      isNew: false,
      step: 4,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'A. 整合性の確認表作成準備入力', to: { name: 'confirmationIndex' }, exact: true },
        { text: '保存確認' },
      ],
    },
  },
]
